import { useCallback, useState } from 'react';
export const useService = request => {
  const [state, setState] = useState({
    loading: false,
    data: undefined,
    error: undefined
  });
  const fetch = useCallback(async requestData => {
    setState({
      loading: true,
      error: undefined,
      data: undefined
    });
    try {
      const data = await request(requestData);
      setState({
        loading: false,
        error: undefined,
        data
      });
      return data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      setState({
        loading: false,
        error,
        data: undefined
      });
      return undefined;
    }
  }, [request]);
  return {
    ...state,
    fetch
  };
};